export const ERROR_CODES = {
    // TODO uncomment if is decided to show modal in all cases
    // something_wrong: [
    //   1000, 1001, 1002, 1003, 1004, 1005, 1006, 1007, 1008, 1009, 1010, 9999, 2002, 3001, 3003, 3004,
    //   3005, 4001, 4002, 7001, 7002, 7005, 7010, 7020, 7030, 7035, 7036, 7037, 7040, 7050, 7060, 7070,
    //   7080, 7090, 8001,
    // ],
    insufficient_funds: [2006],
    prepaid_card: [2003],
    method_issue: [
        // TODO uncomment 2003 and delete prepaid_card param if is decided not to show it separately
        // 2003,
        2001, 2004, 2005, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 3002,
    ],
    check_data: [2019, 2020],
    failed_3D_secure: [2021, 2022],
};
